import React from 'react'
import { FaWhatsapp } from 'react-icons/fa6'

function Team({ name, number }) {

    const openWhatsapp = () => {
        const text = encodeURIComponent(`Hi ${name}, i placed an order and it includes customisation`)
        const url = `https://wa.me/${number}?text=${text}`;
        window.open(url, '_blank')
    }


    return (
        <div className="bg-white p-5 rounded-lg flex justify-between gap-5 items-center">
            <div>
                <h3 className="text-[clamp(1rem,2vw+0.9rem,1.11rem)] font-medium font-serif">{name}</h3>
                <a href={`tel:+${number}`} className="text-blue-600 underline text-sm">{number}</a>
            </div>

            <div>
                <button onClick={openWhatsapp} title='Whatsapp' className='size-10 bg-green-700 rounded-full flex items-center justify-center text-white'>
                    <FaWhatsapp />
                </button>
            </div>
        </div>
    )
}

export default Team